import { isFeatureEnabled } from 'owa-feature-flags';

export function isRemoveDeleteConfirmationDialogFlightEnabled() {
    return (
        isFeatureEnabled('cal-removeDeleteConfirmationDialog') ||
        isFeatureEnabled('cal-removeDeleteConfirmationWithUndoDurationTenSeconds') ||
        isFeatureEnabled('cal-removeDeleteConfirmationWithUndoDurationSevenSeconds')
    );
}
